 <div [id]="'Drug_nudge_inner_card-'+drugData?.medicine_type" class="pharma-detail-drug clearfix overflow-hidden" (click)="redirectDetail()"
    [ngClass]="{'cursor-pointer': (drugData.flags === null || drugData.flags?.content_visibility?.display === contentVisibility.VISIBLE)}">
    <div class="position-absolute w-100 h-100 masking-div"
      *ngIf="drugData.flags?.content_visibility?.display=== contentVisibility.MASKING  || drugData.flags?.content_visibility?.display=== contentVisibility.SUBMITTED">
      <app-product-masking-card [content_visibility]="drugData.flags?.content_visibility"></app-product-masking-card>
    </div>
    <div class="overflow-hidden position-relative">
      <img loading="lazy" src={{drugData.logo}} alt="drugLogo" class="pharma-detail-drug-img w-100"
        onerror="this.src='assets/themes/icons/banner-placeholder.svg'" />
    </div>
    <div>
      <p [id]="'Drug-title-'+ drugData?.name"class="heading-4 mt-2">
        {{ (drugData?.name?.length>42)? (drugData.name | slice:0:42)+'...':(drugData.name) }}
      </p>
      <p class="secondary-paragraph-bold mt-2 mb-2 d-flex align-items-center">
        <span class="mr-2 pr-1 position-relative ">
          <img class="pharma-detail-drug-powered-img rounded-circle d-inline " alt="pharmaLogo"
            onerror="this.src='assets/themes/icons/profilepic.svg'" [src]='drugData.pharma_logo' width="20" height="20">
        </span>
        <span [id]="'Specality-name-' + drugData?.pharma_name" class="color-grey-700 name-max-width">{{drugData.pharma_name}}</span>
      </p>
      <p class="secondary-paragraph">
        <span [id]="'Specality-'+ drugData.flags?.therapeutic_names" class="color-grey-700">
          {{drugData.flags?.therapeutic_names}}
        </span>
      </p>
    </div>
  </div>